export const en = {
    'sizes-title': 'Sizes'
};
